/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WidgetConfiguration {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return WidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<WidgetConfiguration>): WidgetConfiguration {
        let obj = Object.assign(new WidgetConfiguration(), model);
        WidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WidgetConfiguration>): WidgetConfiguration {
        if (!model) return null;
        return WidgetConfiguration.newInstance(<WidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WidgetConfiguration) {
        if (!obj) return;

        models.WidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WidgetConfiguration): boolean {
        switch (obj.__type)
        {
            case "AccessViolationsByCloudAccountWidgetConfiguration":
                Object.setPrototypeOf(obj, models.AccessViolationsByCloudAccountWidgetConfiguration.prototype);
                break;
            case "AccessViolationsTrendWidgetConfiguration":
                Object.setPrototypeOf(obj, models.AccessViolationsTrendWidgetConfiguration.prototype);
                break;
            case "AiAgentChartConfiguration":
                Object.setPrototypeOf(obj, models.AiAgentChartConfiguration.prototype);
                break;
            case "AiAgentDataTableConfiguration":
                Object.setPrototypeOf(obj, models.AiAgentDataTableConfiguration.prototype);
                break;
            case "AiAgenticInsightsConfiguration":
                Object.setPrototypeOf(obj, models.AiAgenticInsightsConfiguration.prototype);
                break;
            case "AiTopResourceWidgetConfiguration":
                Object.setPrototypeOf(obj, models.AiTopResourceWidgetConfiguration.prototype);
                break;
            case "AppInsightsActionableRecommendationsWidgetConfiguration":
                Object.setPrototypeOf(obj, models.AppInsightsActionableRecommendationsWidgetConfiguration.prototype);
                break;
            case "AppSecOpsVulnerabilityByRegionWidgetConfiguration":
                Object.setPrototypeOf(obj, models.AppSecOpsVulnerabilityByRegionWidgetConfiguration.prototype);
                break;
            case "BaseChartWidgetConfigurationModel":
                Object.setPrototypeOf(obj, models.BaseChartWidgetConfigurationModel.prototype);
                break;
            case "BaseCostTrendWidgetConfigurationModel":
                Object.setPrototypeOf(obj, models.BaseCostTrendWidgetConfigurationModel.prototype);
                break;
            case "BaseDataWidgetConfigurationModel":
                Object.setPrototypeOf(obj, models.BaseDataWidgetConfigurationModel.prototype);
                break;
            case "BaseDimensionWidgetConfiguration":
                Object.setPrototypeOf(obj, models.BaseDimensionWidgetConfiguration.prototype);
                break;
            case "BaseGroupByDataWidgetConfigurationModel":
                Object.setPrototypeOf(obj, models.BaseGroupByDataWidgetConfigurationModel.prototype);
                break;
            case "BaseProducerDataWidgetConfigurationModel":
                Object.setPrototypeOf(obj, models.BaseProducerDataWidgetConfigurationModel.prototype);
                break;
            case "BudgetCostTrendWidgetConfiguration":
                Object.setPrototypeOf(obj, models.BudgetCostTrendWidgetConfiguration.prototype);
                break;
            case "BudgetDriftWidgetConfiguration":
                Object.setPrototypeOf(obj, models.BudgetDriftWidgetConfiguration.prototype);
                break;
            case "ChargeDescriptionWidgetConfiguration":
                Object.setPrototypeOf(obj, models.ChargeDescriptionWidgetConfiguration.prototype);
                break;
            case "CloudAccountComplianceSummaryWidgetConfiguration":
                Object.setPrototypeOf(obj, models.CloudAccountComplianceSummaryWidgetConfiguration.prototype);
                break;
            case "CloudForecasterForSixMonthsWidgetConfiguration":
                Object.setPrototypeOf(obj, models.CloudForecasterForSixMonthsWidgetConfiguration.prototype);
                break;
            case "ControlHealthWidgetConfiguration":
                Object.setPrototypeOf(obj, models.ControlHealthWidgetConfiguration.prototype);
                break;
            case "ControlViolationsWithHighRiskLevelWidgetConfiguration":
                Object.setPrototypeOf(obj, models.ControlViolationsWithHighRiskLevelWidgetConfiguration.prototype);
                break;
            case "ControlViolationsWithStandardCoverageWidgetConfiguration":
                Object.setPrototypeOf(obj, models.ControlViolationsWithStandardCoverageWidgetConfiguration.prototype);
                break;
            case "CostAnomalyByCloudWidgetConfiguration":
                Object.setPrototypeOf(obj, models.CostAnomalyByCloudWidgetConfiguration.prototype);
                break;
            case "CostAnomalyImpactByBillingWidgetConfiguration":
                Object.setPrototypeOf(obj, models.CostAnomalyImpactByBillingWidgetConfiguration.prototype);
                break;
            case "CostAnomalyImpactByCloudAccountWidgetConfiguration":
                Object.setPrototypeOf(obj, models.CostAnomalyImpactByCloudAccountWidgetConfiguration.prototype);
                break;
            case "CostAnomalyImpactByEventWidgetConfiguration":
                Object.setPrototypeOf(obj, models.CostAnomalyImpactByEventWidgetConfiguration.prototype);
                break;
            case "CostAnomalyImpactTrendWidgetConfiguration":
                Object.setPrototypeOf(obj, models.CostAnomalyImpactTrendWidgetConfiguration.prototype);
                break;
            case "CostAnomalySpendTrendByResourceIdWidgetConfiguration":
                Object.setPrototypeOf(obj, models.CostAnomalySpendTrendByResourceIdWidgetConfiguration.prototype);
                break;
            case "CostAnomalySpendTrendWidgetConfiguration":
                Object.setPrototypeOf(obj, models.CostAnomalySpendTrendWidgetConfiguration.prototype);
                break;
            case "CostAwsEdpConfiguration":
                Object.setPrototypeOf(obj, models.CostAwsEdpConfiguration.prototype);
                break;
            case "CostAzureMaccCommitmentBurndownConfiguration":
                Object.setPrototypeOf(obj, models.CostAzureMaccCommitmentBurndownConfiguration.prototype);
                break;
            case "CostForAzureMaccCommitmentConfiguration":
                Object.setPrototypeOf(obj, models.CostForAzureMaccCommitmentConfiguration.prototype);
                break;
            case "CostImpactByCategoryWidgetConfiguration":
                Object.setPrototypeOf(obj, models.CostImpactByCategoryWidgetConfiguration.prototype);
                break;
            case "CostImpactByDimensionGroupWidgetConfiguration":
                Object.setPrototypeOf(obj, models.CostImpactByDimensionGroupWidgetConfiguration.prototype);
                break;
            case "CostOptimizationByOptimizationTypeWidgetConfiguration":
                Object.setPrototypeOf(obj, models.CostOptimizationByOptimizationTypeWidgetConfiguration.prototype);
                break;
            case "CostOptimizationTrendWidgetConfiguration":
                Object.setPrototypeOf(obj, models.CostOptimizationTrendWidgetConfiguration.prototype);
                break;
            case "CostSpendByCloudAccountWidgetConfiguration":
                Object.setPrototypeOf(obj, models.CostSpendByCloudAccountWidgetConfiguration.prototype);
                break;
            case "CostSpendByCloudResourceWidgetConfiguration":
                Object.setPrototypeOf(obj, models.CostSpendByCloudResourceWidgetConfiguration.prototype);
                break;
            case "CostSpendByCloudTenantWidgetConfiguration":
                Object.setPrototypeOf(obj, models.CostSpendByCloudTenantWidgetConfiguration.prototype);
                break;
            case "CostSpendByCloudWidgetConfiguration":
                Object.setPrototypeOf(obj, models.CostSpendByCloudWidgetConfiguration.prototype);
                break;
            case "CostSpendByDimensionWidgetConfiguration":
                Object.setPrototypeOf(obj, models.CostSpendByDimensionWidgetConfiguration.prototype);
                break;
            case "CostSpendByHierarchyWidgetConfiguration":
                Object.setPrototypeOf(obj, models.CostSpendByHierarchyWidgetConfiguration.prototype);
                break;
            case "CostSpendByRegionWidgetConfiguration":
                Object.setPrototypeOf(obj, models.CostSpendByRegionWidgetConfiguration.prototype);
                break;
            case "CostSpendByTagLevelWidgetConfiguration":
                Object.setPrototypeOf(obj, models.CostSpendByTagLevelWidgetConfiguration.prototype);
                break;
            case "CostSummaryWidgetConfigurationModel":
                Object.setPrototypeOf(obj, models.CostSummaryWidgetConfigurationModel.prototype);
                break;
            case "CostTrendByCloudWidgetConfiguration":
                Object.setPrototypeOf(obj, models.CostTrendByCloudWidgetConfiguration.prototype);
                break;
            case "CostTrendByDimensionGroupWidgetConfiguration":
                Object.setPrototypeOf(obj, models.CostTrendByDimensionGroupWidgetConfiguration.prototype);
                break;
            case "CostTrendByResourceCategoryWidgetConfiguration":
                Object.setPrototypeOf(obj, models.CostTrendByResourceCategoryWidgetConfiguration.prototype);
                break;
            case "CostTrendForecastWidgetConfiguration":
                Object.setPrototypeOf(obj, models.CostTrendForecastWidgetConfiguration.prototype);
                break;
            case "CostTrendWidgetConfiguration":
                Object.setPrototypeOf(obj, models.CostTrendWidgetConfiguration.prototype);
                break;
            case "CostVariationByDimensionWidgetConfiguration":
                Object.setPrototypeOf(obj, models.CostVariationByDimensionWidgetConfiguration.prototype);
                break;
            case "CostVariationWidgetConfiguration":
                Object.setPrototypeOf(obj, models.CostVariationWidgetConfiguration.prototype);
                break;
            case "DimensionBudgetWidgetConfiguration":
                Object.setPrototypeOf(obj, models.DimensionBudgetWidgetConfiguration.prototype);
                break;
            case "FilterContextWidgetConfigurationModel":
                Object.setPrototypeOf(obj, models.FilterContextWidgetConfigurationModel.prototype);
                break;
            case "FilterWidgetConfiguration":
                Object.setPrototypeOf(obj, models.FilterWidgetConfiguration.prototype);
                break;
            case "GroupingWidgetConfiguration":
                Object.setPrototypeOf(obj, models.GroupingWidgetConfiguration.prototype);
                break;
            case "ImageWidgetConfiguration":
                Object.setPrototypeOf(obj, models.ImageWidgetConfiguration.prototype);
                break;
            case "InfrastructureResourcesByResourceCategoryWidgetConfiguration":
                Object.setPrototypeOf(obj, models.InfrastructureResourcesByResourceCategoryWidgetConfiguration.prototype);
                break;
            case "InfrastructureResourcesInventoryOverviewWidgetConfiguration":
                Object.setPrototypeOf(obj, models.InfrastructureResourcesInventoryOverviewWidgetConfiguration.prototype);
                break;
            case "InfrastructureResourcesIssuesFlowWidgetConfiguration":
                Object.setPrototypeOf(obj, models.InfrastructureResourcesIssuesFlowWidgetConfiguration.prototype);
                break;
            case "KubernetesCostSpendByDimensionWidgetConfiguration":
                Object.setPrototypeOf(obj, models.KubernetesCostSpendByDimensionWidgetConfiguration.prototype);
                break;
            case "KubernetesCostSummaryWidgetConfigurationModel":
                Object.setPrototypeOf(obj, models.KubernetesCostSummaryWidgetConfigurationModel.prototype);
                break;
            case "KubernetesCostTrendForecastWidgetConfiguration":
                Object.setPrototypeOf(obj, models.KubernetesCostTrendForecastWidgetConfiguration.prototype);
                break;
            case "KubernetesCostTrendWidgetConfiguration":
                Object.setPrototypeOf(obj, models.KubernetesCostTrendWidgetConfiguration.prototype);
                break;
            case "MisconfigurationExplorerWidgetConfiguration":
                Object.setPrototypeOf(obj, models.MisconfigurationExplorerWidgetConfiguration.prototype);
                break;
            case "MisconfigurationViolationsByCloudAccountWidgetConfiguration":
                Object.setPrototypeOf(obj, models.MisconfigurationViolationsByCloudAccountWidgetConfiguration.prototype);
                break;
            case "MisconfigurationViolationsByCloudProviderWidgetConfiguration":
                Object.setPrototypeOf(obj, models.MisconfigurationViolationsByCloudProviderWidgetConfiguration.prototype);
                break;
            case "MisconfigurationViolationsByRegionWidgetConfiguration":
                Object.setPrototypeOf(obj, models.MisconfigurationViolationsByRegionWidgetConfiguration.prototype);
                break;
            case "MisconfigurationViolationsTrendWidgetConfiguration":
                Object.setPrototypeOf(obj, models.MisconfigurationViolationsTrendWidgetConfiguration.prototype);
                break;
            case "OpenInfrastructureVulnerabilitiesByTrendWidgetConfiguration":
                Object.setPrototypeOf(obj, models.OpenInfrastructureVulnerabilitiesByTrendWidgetConfiguration.prototype);
                break;
            case "OpenVulnerabilitiesBySeverityWidgetConfiguration":
                Object.setPrototypeOf(obj, models.OpenVulnerabilitiesBySeverityWidgetConfiguration.prototype);
                break;
            case "ResourceByProductCategoryWidgetConfiguration":
                Object.setPrototypeOf(obj, models.ResourceByProductCategoryWidgetConfiguration.prototype);
                break;
            case "TabWidgetConfiguration":
                Object.setPrototypeOf(obj, models.TabWidgetConfiguration.prototype);
                break;
            case "TagLevelTrendWidgetConfiguration":
                Object.setPrototypeOf(obj, models.TagLevelTrendWidgetConfiguration.prototype);
                break;
            case "TenantComplianceSummaryWidgetConfiguration":
                Object.setPrototypeOf(obj, models.TenantComplianceSummaryWidgetConfiguration.prototype);
                break;
            case "TenantComplianceTrendWidgetConfiguration":
                Object.setPrototypeOf(obj, models.TenantComplianceTrendWidgetConfiguration.prototype);
                break;
            case "TextWidgetConfiguration":
                Object.setPrototypeOf(obj, models.TextWidgetConfiguration.prototype);
                break;
            case "ThreatExplorerWidgetConfiguration":
                Object.setPrototypeOf(obj, models.ThreatExplorerWidgetConfiguration.prototype);
                break;
            case "ThreatsByCloudAccountWidgetConfiguration":
                Object.setPrototypeOf(obj, models.ThreatsByCloudAccountWidgetConfiguration.prototype);
                break;
            case "ThreatsByRegionWidgetConfiguration":
                Object.setPrototypeOf(obj, models.ThreatsByRegionWidgetConfiguration.prototype);
                break;
            case "ThreatsConcentrationByProviderWidgetConfiguration":
                Object.setPrototypeOf(obj, models.ThreatsConcentrationByProviderWidgetConfiguration.prototype);
                break;
            case "ThreatsTrendWidgetConfiguration":
                Object.setPrototypeOf(obj, models.ThreatsTrendWidgetConfiguration.prototype);
                break;
            case "TopBudgetByTenantWidgetConfiguration":
                Object.setPrototypeOf(obj, models.TopBudgetByTenantWidgetConfiguration.prototype);
                break;
            case "TopCostOptimizationWidgetConfiguration":
                Object.setPrototypeOf(obj, models.TopCostOptimizationWidgetConfiguration.prototype);
                break;
            case "TopPodWidgetConfiguration":
                Object.setPrototypeOf(obj, models.TopPodWidgetConfiguration.prototype);
                break;
            case "TopResourcesWidgetConfiguration":
                Object.setPrototypeOf(obj, models.TopResourcesWidgetConfiguration.prototype);
                break;
            case "VulnerabilitiesBySeverityByAccountWidgetConfiguration":
                Object.setPrototypeOf(obj, models.VulnerabilitiesBySeverityByAccountWidgetConfiguration.prototype);
                break;
            case "VulnerabilitiesOverBuildWidgetConfiguration":
                Object.setPrototypeOf(obj, models.VulnerabilitiesOverBuildWidgetConfiguration.prototype);
                break;
            case "VulnerabilityByAgeWidgetConfiguration":
                Object.setPrototypeOf(obj, models.VulnerabilityByAgeWidgetConfiguration.prototype);
                break;
            case "VulnerabilityByCloudAccountWidgetConfiguration":
                Object.setPrototypeOf(obj, models.VulnerabilityByCloudAccountWidgetConfiguration.prototype);
                break;
            case "VulnerabilityByProductWidgetConfiguration":
                Object.setPrototypeOf(obj, models.VulnerabilityByProductWidgetConfiguration.prototype);
                break;
            case "VulnerabilityByRegionWidgetConfiguration":
                Object.setPrototypeOf(obj, models.VulnerabilityByRegionWidgetConfiguration.prototype);
                break;
            case "VulnerabilityBySeverityAndKevWidgetConfiguration":
                Object.setPrototypeOf(obj, models.VulnerabilityBySeverityAndKevWidgetConfiguration.prototype);
                break;
            case "VulnerabilityExplorerWidgetConfiguration":
                Object.setPrototypeOf(obj, models.VulnerabilityExplorerWidgetConfiguration.prototype);
                break;
            case "VulnerabilityTrendWidgetConfiguration":
                Object.setPrototypeOf(obj, models.VulnerabilityTrendWidgetConfiguration.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof WidgetConfiguration)[] {
        return [
            models.AccessViolationsByCloudAccountWidgetConfiguration,
            models.AccessViolationsTrendWidgetConfiguration,
            models.AiAgentChartConfiguration,
            models.AiAgentDataTableConfiguration,
            models.AiAgenticInsightsConfiguration,
            models.AiTopResourceWidgetConfiguration,
            models.AppInsightsActionableRecommendationsWidgetConfiguration,
            models.AppSecOpsVulnerabilityByRegionWidgetConfiguration,
            models.BaseChartWidgetConfigurationModel,
            models.BaseCostTrendWidgetConfigurationModel,
            models.BaseDataWidgetConfigurationModel,
            models.BaseDimensionWidgetConfiguration,
            models.BaseGroupByDataWidgetConfigurationModel,
            models.BaseProducerDataWidgetConfigurationModel,
            models.BudgetCostTrendWidgetConfiguration,
            models.BudgetDriftWidgetConfiguration,
            models.ChargeDescriptionWidgetConfiguration,
            models.CloudAccountComplianceSummaryWidgetConfiguration,
            models.CloudForecasterForSixMonthsWidgetConfiguration,
            models.ControlHealthWidgetConfiguration,
            models.ControlViolationsWithHighRiskLevelWidgetConfiguration,
            models.ControlViolationsWithStandardCoverageWidgetConfiguration,
            models.CostAnomalyByCloudWidgetConfiguration,
            models.CostAnomalyImpactByBillingWidgetConfiguration,
            models.CostAnomalyImpactByCloudAccountWidgetConfiguration,
            models.CostAnomalyImpactByEventWidgetConfiguration,
            models.CostAnomalyImpactTrendWidgetConfiguration,
            models.CostAnomalySpendTrendByResourceIdWidgetConfiguration,
            models.CostAnomalySpendTrendWidgetConfiguration,
            models.CostAwsEdpConfiguration,
            models.CostAzureMaccCommitmentBurndownConfiguration,
            models.CostForAzureMaccCommitmentConfiguration,
            models.CostImpactByCategoryWidgetConfiguration,
            models.CostImpactByDimensionGroupWidgetConfiguration,
            models.CostOptimizationByOptimizationTypeWidgetConfiguration,
            models.CostOptimizationTrendWidgetConfiguration,
            models.CostSpendByCloudAccountWidgetConfiguration,
            models.CostSpendByCloudResourceWidgetConfiguration,
            models.CostSpendByCloudTenantWidgetConfiguration,
            models.CostSpendByCloudWidgetConfiguration,
            models.CostSpendByDimensionWidgetConfiguration,
            models.CostSpendByHierarchyWidgetConfiguration,
            models.CostSpendByRegionWidgetConfiguration,
            models.CostSpendByTagLevelWidgetConfiguration,
            models.CostSummaryWidgetConfigurationModel,
            models.CostTrendByCloudWidgetConfiguration,
            models.CostTrendByDimensionGroupWidgetConfiguration,
            models.CostTrendByResourceCategoryWidgetConfiguration,
            models.CostTrendForecastWidgetConfiguration,
            models.CostTrendWidgetConfiguration,
            models.CostVariationByDimensionWidgetConfiguration,
            models.CostVariationWidgetConfiguration,
            models.DimensionBudgetWidgetConfiguration,
            models.FilterContextWidgetConfigurationModel,
            models.FilterWidgetConfiguration,
            models.GroupingWidgetConfiguration,
            models.ImageWidgetConfiguration,
            models.InfrastructureResourcesByResourceCategoryWidgetConfiguration,
            models.InfrastructureResourcesInventoryOverviewWidgetConfiguration,
            models.InfrastructureResourcesIssuesFlowWidgetConfiguration,
            models.KubernetesCostSpendByDimensionWidgetConfiguration,
            models.KubernetesCostSummaryWidgetConfigurationModel,
            models.KubernetesCostTrendForecastWidgetConfiguration,
            models.KubernetesCostTrendWidgetConfiguration,
            models.MisconfigurationExplorerWidgetConfiguration,
            models.MisconfigurationViolationsByCloudAccountWidgetConfiguration,
            models.MisconfigurationViolationsByCloudProviderWidgetConfiguration,
            models.MisconfigurationViolationsByRegionWidgetConfiguration,
            models.MisconfigurationViolationsTrendWidgetConfiguration,
            models.OpenInfrastructureVulnerabilitiesByTrendWidgetConfiguration,
            models.OpenVulnerabilitiesBySeverityWidgetConfiguration,
            models.ResourceByProductCategoryWidgetConfiguration,
            models.TabWidgetConfiguration,
            models.TagLevelTrendWidgetConfiguration,
            models.TenantComplianceSummaryWidgetConfiguration,
            models.TenantComplianceTrendWidgetConfiguration,
            models.TextWidgetConfiguration,
            models.ThreatExplorerWidgetConfiguration,
            models.ThreatsByCloudAccountWidgetConfiguration,
            models.ThreatsByRegionWidgetConfiguration,
            models.ThreatsConcentrationByProviderWidgetConfiguration,
            models.ThreatsTrendWidgetConfiguration,
            models.TopBudgetByTenantWidgetConfiguration,
            models.TopCostOptimizationWidgetConfiguration,
            models.TopPodWidgetConfiguration,
            models.TopResourcesWidgetConfiguration,
            models.VulnerabilitiesBySeverityByAccountWidgetConfiguration,
            models.VulnerabilitiesOverBuildWidgetConfiguration,
            models.VulnerabilityByAgeWidgetConfiguration,
            models.VulnerabilityByCloudAccountWidgetConfiguration,
            models.VulnerabilityByProductWidgetConfiguration,
            models.VulnerabilityByRegionWidgetConfiguration,
            models.VulnerabilityBySeverityAndKevWidgetConfiguration,
            models.VulnerabilityExplorerWidgetConfiguration,
            models.VulnerabilityTrendWidgetConfiguration,
        ];
    }

    fixupFields() {
        if (this.size === undefined) {
            this.size = 0;
        }
        if (this.refreshRateInSeconds === undefined) {
            this.refreshRateInSeconds = 0;
        }
        if (this.fontMultiplier === undefined) {
            this.fontMultiplier = 0;
        }
    }

    id: string;

    size: number;

    name: string;

    description: string;

    refreshRateInSeconds: number;

    manualFontScaling: boolean;

    fontMultiplier: number;

    /**
     * Behavior of the widget toolbar
     */
    toolbarBehavior: models.WidgetToolbarBehavior;

}
